import React from "react";
import { Box, Button, Container, Grid, Stack, Typography, useMediaQuery } from "@mui/material";
import ExpIcon from "../assets/explore icon.svg";
import ResearchIcon from "../assets/Research icon.png";
import ResearchPalLogo from "../assets/Logos/researhcpal.png";
import styled from "@emotion/styled";
import Separator from "../assets/Separator.svg";

// New product logos
import DataLumioLogo from "../assets/Logos/DataLumioLogo.png";
import HypergrowthLogo from "../assets/Logos/hypergrowth.png";
import ManageKaroLogo from "../assets/Logos/managekaro.png";
import PapuAILogo from "../assets/Logos/papuai.png";

const RootStyle = styled(Box)(({ theme }) => ({
  background: "#121831",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const ToolCard = styled(Box)({
  maxWidth: "350px",
  minHeight: "420px",
  width: "100%",
  background:
    "linear-gradient(142.21deg, rgba(27, 51, 81, 0.3) 19.63%, rgba(67, 144, 238, 0.3) 83.01%)",
  backgroundBlendMode: "overlay",
  border: "0.6px solid",
  boxShadow: "0px 23.9px 23.9px 0px #00000040",
  borderImageSource:
    "linear-gradient(178.6deg, #FFFFFF 13.55%, rgba(0, 0, 0, 0.15) 83.77%)",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const BtnExplore = styled(Button)(({ theme }) => ({
  textTransform: "none",
  borderRadius: "10px",
  color: "var(--sengrey, #C2C2C2)",
  background:
    "linear-gradient(180deg, rgba(49, 58, 91, 0.00) 0%, #313A5B 78.91%, rgba(49, 58, 91, 0.22) 100%) !important",
  border: "1px solid",
  borderColor: "linear-gradient(rgba(255, 255, 255, 1), rgba(0, 0, 0, 1)",
}));

const productCards = [
  {
    id: "researchpal",
    logo: ResearchPalLogo,
    name: "ResearchPal",
    description: "For the Researchers, By the Researchers",
    link: "https://researchpal.co",
    gradient: "linear-gradient(180deg, #3C87FF 0%, #3CDBFF 100%)",
    logoHeight: { lg: "120px", sm: "90px" },
  },
  {
    id: "datalumio",
    logo: DataLumioLogo,
    name: "DataLumio",
    description: "AI-powered insights for everyone.",
    link: "https://datalumio.co/",
    gradient: "linear-gradient(180deg, #4F46E5 0%, #7C3AED 100%)",
    logoHeight: { lg: "120px", sm: "90px" },
  },
  {
    id: "hypergrowth",
    logo: HypergrowthLogo,
    name: "Hypergrowth",
    description: "Create, Automate, Grow. Your AI growth engine.",
    link: "https://hypergrowthai.co/",
    gradient: "linear-gradient(180deg, #F97316 0%, #EF4444 100%)",
    logoHeight: { lg: "120px", sm: "90px" },
  },
  {
    id: "managekaro",
    logo: ManageKaroLogo,
    name: "ManageKaro",
    description: "Everything your business needs, in one place.",
    link: "https://managekaro.org/",
    gradient: "linear-gradient(180deg, #10B981 0%, #059669 100%)",
    logoHeight: { lg: "120px", sm: "90px" },
  },
  {
    id: "papuai",
    logo: PapuAILogo,
    name: "Papu AI",
    description: "Turn ideas into videos. Create videos at the speed of thought.",
    link: "https://papu.ai/",
    gradient: "linear-gradient(180deg, #EC4899 0%, #8B5CF6 100%)",
    logoHeight: { lg: "120px", sm: "90px" },
  },
];

function Tools() {
  const isLarge = useMediaQuery("(min-width:1200px)");
  const moreLarge = useMediaQuery("(min-width:1300px)");

  return (
    <RootStyle sx={{ px: 3, py: moreLarge ? 3 : 0 }}>
      <Container
        sx={{
          mt: {
            xs: 4,
            sm: 4,
          },
        }}
      >
        <Grid container spacing={5} justifyContent="center">
          {productCards.map((card) => (
            <Grid key={card.id} item md={4} sm={6} xs={12} align="center">
              <ToolCard sx={{ borderRadius: "20px" }}>
                <Stack
                  p={3}
                  alignItems="center"
                  justifyContent="center"
                  spacing={isLarge ? 3.5 : 3}
                >
                  <img
                    src={card.logo}
                    alt={card.name}
                    style={{
                      height: isLarge
                        ? card.logoHeight.lg
                        : card.logoHeight.sm,
                      objectFit: "contain",
                    }}
                  />
                  <Typography
                    sx={{
                      backgroundImage: card.gradient,
                      backgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      fontFamily: "Righteous",
                      fontWeight: 400,
                      fontSize: "24px",
                    }}
                  >
                    {card.name}
                  </Typography>

                  <Typography
                    sx={{
                      color: "#FFFFFF",
                      fontFamily: "Raleway",
                      fontWeight: 400,
                      fontSize: "15px",
                      textAlign: "center",
                      pb: { xs: 1, sm: 3, lg: 5 },
                    }}
                  >
                    {card.description}
                  </Typography>
                  <a href={card.link} target="_blank" rel="noopener noreferrer">
                    <BtnExplore variant="contained">
                      <img
                        style={{ marginRight: "5px" }}
                        src={ExpIcon}
                        alt=""
                      />
                      Explore Now
                    </BtnExplore>
                  </a>
                </Stack>
              </ToolCard>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "center", mt: { xs: 2.5, sm: 4 } }}>
          <img width="100%" src={Separator} alt="" />
        </Box>
      </Container>
    </RootStyle>
  );
}

export default Tools;
